import { render, staticRenderFns } from "./CYtable.vue?vue&type=template&id=6a47c036&scoped=true"
import script from "./CYtable.vue?vue&type=script&lang=js"
export * from "./CYtable.vue?vue&type=script&lang=js"
import style0 from "./CYtable.vue?vue&type=style&index=0&id=6a47c036&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a47c036",
  null
  
)

export default component.exports